<template>
    <div class="phone-input">
        <svg aria-hidden="true" class="phone-icon">
            <use href="#icon-svg-phoneIcon" fill="#fff"></use>
        </svg>
        <div class="separator">|</div>
        <span class="country-code">+254</span>
        <input
            v-if="showinput"
            type="tel"
            v-model="phoneNumber"
            :placeholder="$t('security.account_input.placeholder_phone')"
            class="phone-number-input"
            @input="handleInput"
        />
        <button v-else :class="['phone-number-input', 'btn']" @click="editBindInfo">
            {{ modelValue || $t('security.account_input.placeholder_phone') }}
        </button>
        <div class="edit-btn" v-if="showedit" @click="editBindInfo"></div>
    </div>
</template>

<script setup lang="ts">
import { defineComponent, ref } from 'vue'

interface Emits {
    (e: 'update:modelValue', value: string): void
    (e: 'editBindInfo', value: string): void
}
const emit = defineEmits<Emits>()

defineProps({
    modelValue: {
        type: String,
        default: '',
    },
    showedit: {
        type: Boolean,
        default: true,
    },
    showinput: {
        type: Boolean,
        default: false,
    },
})
const phoneNumber = ref('')

const handleInput = (event: Event) => {
    const input = event.target as HTMLInputElement
    const sanitizedValue = formatNumber(input.value)
    phoneNumber.value = sanitizedValue
    emit('update:modelValue', sanitizedValue)
}

function formatNumber(input) {
    if (input == null) return ''

    const numbers = String(input).replace(/[^\d]/g, '')

    if (numbers.startsWith('0')) {
        return numbers.slice(0, 10)
    } else {
        return numbers.slice(0, 9)
    }
}

const editBindInfo = () => {
    emit('editBindInfo', '')
}
</script>

<style lang="scss" scoped>
.phone-input {
    display: flex;
    align-items: center;
    border: 1px solid #ccc;
    border-radius: 10px;
    width: auto;
    height: 66px;
    margin-top: 20px;
}

.phone-icon {
    width: 60px;
    height: 60px;
    margin-left: 8px;
    padding: 8px;
}

.separator {
    font-size: 30px;
    margin: 0 8px;
}

.country-code {
    margin-right: 8px;
    font-weight: bold;
    font-size: 30px;
    color: #ccc;
}

.phone-number-input {
    width: auto;
    height: 100%;
    border: none;
    font-size: 30px;
    padding: 8px;
    flex-grow: 1;
    background-color: #ccc2;
    border-radius: 0 10px 10px 0;
    color: #fff;
    text-align: left;

    &::placeholder {
        color: #8eaaba;
    }

    &.btn {
        color: #8eaaba;
    }
}

.edit-btn {
    position: absolute;
    width: 70px;
    height: 70px;
    right: 20px;
    &::after {
        display: inline-block;
        content: '';
        width: 36px;
        height: 36px;
        background: url('@/assets/img/wallets/edit.png') no-repeat;
        background-size: 100% 100%;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
}
</style>
